import {Fichier} from './fichier.model';

export class Archive {
    constructor(
        public label?: string,
        public fichier?: Fichier,
        public annee?: Number,
        public anneeCourante?: Number
) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/archive/archive.model.ts